module.exports = __webpack_public_path__ + "ltg_logo.svg?aa897e9874a66ae90c5fbb3f9c4aede5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ltg_logo.svg
// module id = 58
// module chunks = 0